module.exports = "/packs/mastercard-58b808d6276ff3f1434fefc6a8059ab2.png";